import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'
import { styled } from '@mui/system'

export const Wrapper = styled('div')<{ theme?: TTheme }>`
    overflow-y: auto;
`

export const Title = styled(Typography)<{ theme?: TTheme }>`
    margin: 24px 0;
    color: ${({ theme: { colors } }) => colors.greys[800]};
`
